import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import CheckIcon from "@material-ui/icons/Check";
import Grid from "@material-ui/core/Grid";
import UpiApps from "../../../../utils/icons/upi-apps.png";
import TestQr from "../../../../utils/icons/test-qr.png";
import { fetchUPIQR, submitSimulateQRCallback } from "../../../../actions/upi";
import UpiLogo from "../../../../utils/icons/upiLogo.png";

import "../UpiForm.css";

export const UpiQrPage = ({
  charge,
  dispatch,
  isPolling,
  qrData,
  isQRVisible
}) => {
  const { uuid, testMode } = charge;

  useEffect(() => {
    dispatch(fetchUPIQR(uuid, "false"));
  }, []);

  return (
    <form className="upi-form">
      <Grid container justify="center" spacing={2}>
        {isPolling && (
          <Grid item xs={12} id="upi-polling-indicator">
            <CircularProgress color="secondary" />
            <p>Please accept the payment request on your UPI app.</p>
          </Grid>
        )}
        <Grid item xs={12} style={{ textAlign: "center" }}>
          {isQRVisible && (
            <div>
              <p style={{ fontSize: "17px", fontFamily: "Roboto" }}>
                Scan the QR using any UPI app on your phone.
              </p>
              <span
                className="upi-apps"
                style={{
                  display: "grid",
                  justifyContent: "center",
                  alignContent: "center"
                }}
              >
                <img src={UpiApps} alt="logo" style={{ height: "3.5vh" }} />
              </span>
              {testMode ? (
                <div>
                  <img
                    src={TestQr}
                    alt="logo"
                    style={{ height: "18vh", marginLeft: "8px" }}
                  />
                  <Grid item xs={12} style={{ textAlign: "center" }}>
                    <Button
                      id="simulate-ok-button"
                      onClick={() =>
                        submitSimulateQRCallback(true, uuid, qrData.payload)
                      }
                    >
                      <CheckIcon />
                      &nbsp;Simulate success
                    </Button>
                  </Grid>
                </div>
              ) : (
                <img src={qrData.qrcode} alt="upi-qr" />
              )}
            </div>
          )}
          <Grid
            item
            xs={12}
            style={{ position: "relative", minHeight: "150px" }}
          >
            <div className="upi-logo-container">
              <img alt="Powered by UPI" src={UpiLogo} className="upi-logo" />
            </div>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

UpiQrPage.propTypes = {
  charge: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    testMode: PropTypes.bool.isRequired
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  isPolling: PropTypes.bool.isRequired,
  qrData: PropTypes.string,
  isQRVisible: PropTypes.bool.isRequired
};

UpiQrPage.defaultProps = {
  qrData: undefined
};

function mapStateToProps({ upiReducer }) {
  return upiReducer;
}

export default connect(mapStateToProps)(UpiQrPage);
